import {ApplicationRef} from '@angular/core';

export class ComponentesJsService{

    static animacaoEmBotoes() {
        /*
         * Waves Animation
        */
        (function() {
            Waves.attach('.btn:not(.btn-icon):not(.btn-float)');
            Waves.attach('.btn-icon, .btn-float', ['waves-circle', 'waves-float']);
            Waves.init();
        })();
		

        var scrolltotop = {
            setting: {startline:100, scrollto: 0, scrollduration:1000, fadeduration:[500, 100]},
            controlHTML: '<img id="scroll" src="../../../public/img/topo.png"/>', //HTML for control, which is auto wrapped in DIV w/ ID="topcontrol"
            controlattrs: {offsetx:5, offsety:5}, //offset of control relative to right/ bottom of window corner
            anchorkeyword: '#top', //Enter href value of HTML anchors on the page that should also act as "Scroll Up" links
            state: {isvisible:false, shouldvisible:false},
            scrollup:function(){
                if (!this.cssfixedsupport) //if control is positioned using JavaScript
                    this.$control.css({opacity:0}) //hide control immediately after clicking it
                var dest=isNaN(this.setting.scrollto)? this.setting.scrollto : parseInt(this.setting.scrollto)
                if (typeof dest=="string" && jQuery('#'+dest).length==1) //check element set by string exists
                    dest=jQuery('#'+dest).offset().top
                else
                    dest=0
                this.$body.animate({scrollTop: dest}, this.setting.scrollduration);
            },
            keepfixed:function(){
                var $window=jQuery(window)
                var controlx=$window.scrollLeft() + $window.width() - this.$control.width() - this.controlattrs.offsetx
                var controly=$window.scrollTop() + $window.height() - this.$control.height() - this.controlattrs.offsety
                this.$control.css({left:controlx+'px', top:controly+'px'})
            },
            togglecontrol:function(){
                var scrolltop=jQuery(window).scrollTop()
                if (!this.cssfixedsupport)
                    this.keepfixed()
                this.state.shouldvisible=(scrolltop>=this.setting.startline)? true : false
                if (this.state.shouldvisible && !this.state.isvisible){
                    this.$control.stop().animate({opacity:1}, this.setting.fadeduration[0])
                    this.state.isvisible=true
                }
                else if (this.state.shouldvisible==false && this.state.isvisible){
                    this.$control.stop().animate({opacity:0}, this.setting.fadeduration[1])
                    this.state.isvisible=false
                }
            },
            init:function(){
                jQuery(document).ready(function($){
                    var mainobj=scrolltotop
                    var iebrws=document.all
                    mainobj.cssfixedsupport=!iebrws || iebrws && document.compatMode=="CSS1Compat" && window.XMLHttpRequest //not IE or IE7+ browsers in standards mode
                    mainobj.$body=(window.opera)? (document.compatMode=="CSS1Compat"? $('html') : $('body')) : $('html,body')
                    mainobj.$control=$('<div id="topcontrol">'+mainobj.controlHTML+'</div>')
                        .css({position:mainobj.cssfixedsupport? 'fixed' : 'absolute', bottom:mainobj.controlattrs.offsety, right:mainobj.controlattrs.offsetx, opacity:0, cursor:'pointer'})
                        .attr({title:'Ir ao Topo'})
                        .click(function(){mainobj.scrollup(); return false})
                        .appendTo('body')
                    if (document.all && !window.XMLHttpRequest && mainobj.$control.text()!='') //loose check for IE6 and below, plus whether control contains any text
                        mainobj.$control.css({width:mainobj.$control.width()}) //IE6- seems to require an explicit width on a DIV containing text
                    mainobj.togglecontrol()
                    $('a[href="' + mainobj.anchorkeyword +'"]').click(function(){
                        mainobj.scrollup()
                        return false
                    })
                    $(window).bind('scroll resize', function(e){
                        mainobj.togglecontrol()
                    })
                })
            }
        }
        scrolltotop.init()
    }

    static setMasks()
    {
        $(".cep").mask("99999-999");
        $(".telfixo").mask("(99) 9999-9999");
        $(".cel").mask("(99) 99999-9999");
        $(".hour").mask("99:99");
        $(".date").mask("99/99/9999");
        $(".cpf").mask("999.999.999-99");
        $(".real").mask("#.###.###.##0,00", {reverse: true});
        $(".porcentagem").mask("00,00", {reverse: true});
        $(".cnpj").mask("99.999.999/9999-99");
        $(".competencia").mask("99/9999");
    }

    static setSelectPicker()
    {
        alert('Renderizando selects');
        $('.selectpicker').selectpicker(); // Renderizar o combobox        
    }

    // static setDateTimePickers()
    // {
    //     if ($('.date-time-picker')[0]) {
    //         $('.date-time-picker').datetimepicker();
    //     }

    //     //Time
    //     if ($('.time-picker')[0]) {
    //         $('.time-picker').datetimepicker({
    //             format: 'LT'
    //         });
    //     }

    //     //Date
    //     if ($('.date-picker')[0]) {
    //         $('.date-picker').datetimepicker({
    //             format: 'DD/MM/YYYY',
    //             showTodayButton: true,
    //             minDate: '01/01/1900', //new Date().toLocaleDateString(),
    //             useCurrent: false,
    //         });

    //         $('.date-picker').on('dp.change', (e) => {
    //             //ApplicationRef.tick();
    //             //alert("Hiue");
    //             $(".date-picker").trigger( 'change' );
    //             $(".date-picker").trigger( 'input' );
    //         })            
    //     }
    // }

    static setChosen()
    {
        $('.chosen').chosen({
            width: '100%',
            allow_single_deselect: true
        });
    }

    static setHtmlEditor()
    {
        if ($('.html-editor')[0]) {
        $('.html-editor').summernote({
                height: 150
            });
        }

        if($('.html-editor-click')[0]) {
            //Edit
            $('body').on('click', '.hec-button', function(){
                $('.html-editor-click').summernote({
                    focus: true
                });
                $('.hec-save').show();
            })

            //Save
            $('body').on('click', '.hec-save', function(){
                $('.html-editor-click').code();
                $('.html-editor-click').destroy();
                $('.hec-save').hide();
                //notify('Content Saved Successfully!', 'success');
            });
        }

        //Air Mode
        if($('.html-editor-airmod')[0]) {
            $('.html-editor-airmod').summernote({
                airMode: true
            });
        }
    }

    static validarEmail(email: string){
        var regex = /[^@]+@[^@]+\.[a-zA-Z]{2,6}/;
        if(!regex.test(email)){
            swal("error","E-mail Inválido","error");
            return false;
        }
        else
            return true;
    }

    static validarCPF(cpf: any)
    {
        if(!cpf || cpf == ""){
            swal("error","CPF Inválido","error");
            return false;
        }
            
        var numeros: any, digitos: any, soma: any, i: any, resultado: any, digitos_iguais: any;
        digitos_iguais = 1;
        if (cpf.length < 11)
            return false;
        for (i = 0; i < cpf.length - 1; i++)
            if (cpf.charAt(i) != cpf.charAt(i + 1))
                    {
                    digitos_iguais = 0;
                    break;
                    }
        if (!digitos_iguais)
            {
                numeros = cpf.substring(0,9);
                digitos = cpf.substring(9);
                soma = 0;
                for (i = 10; i > 1; i--)
                        soma += numeros.charAt(10 - i) * i;
                resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if (resultado != digitos.charAt(0)){
                        swal("error","CPF Inválido","error");
                        return false;
                }
                numeros = cpf.substring(0,10);
                soma = 0;
                for (i = 11; i > 1; i--)
                        soma += numeros.charAt(11 - i) * i;
                resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
                if (resultado != digitos.charAt(1)){
                        swal("error","CPF Inválido","error");
                        return false;
                }
                return true;
            }
        else {
             swal("error","CPF Inválido","error");
             return false;
        }
    }

    static validaCNPJ(cnpj: any)
        {

        cnpj = cnpj.replace(/[^\d]+/g,'');
    
        if(cnpj == ''){
            swal("error","CNPJ Inválido","error");
            return false;
        }
        if (cnpj.length != 14){
            swal("error","CNPJ Inválido","error");
            return false;
        }
        // Elimina CNPJs invalidos conhecidos
        if (cnpj == "00000000000000" || 
            cnpj == "11111111111111" || 
            cnpj == "22222222222222" || 
            cnpj == "33333333333333" || 
            cnpj == "44444444444444" || 
            cnpj == "55555555555555" || 
            cnpj == "66666666666666" || 
            cnpj == "77777777777777" || 
            cnpj == "88888888888888" || 
            cnpj == "99999999999999"){
            swal("error","CNPJ Inválido","error");
            return false;
        }
        // Valida DVs
        var tamanho = cnpj.length - 2
        var numeros = cnpj.substring(0,tamanho);
        var digitos = cnpj.substring(tamanho);
        var soma = 0;
        var pos = tamanho - 7;
        for (var i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
                pos = 9;
        }
        var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0)){
            swal("error","CNPJ Inválido","error");
            return false;
        }
        tamanho = tamanho + 1;
        numeros = cnpj.substring(0,tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1)){
            swal("error","CNPJ Inválido","error");
            return false;
        }
            
        return true;
        }

    static validarTamanhoString(value: string, tam: number){
        if(value.length < tam && value.length > 0)
            return false;
        return true;            
    }
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/core/common/services/componentesjs.service.ts
 **/